// extracted by mini-css-extract-plugin
export default {"img__container":"QuestionFive_img__container__E1e+z","label":"QuestionFive_label__qqmAv","buttonContainer":"QuestionFive_buttonContainer__3dL0j"};